import { lazyChunk } from "@/modules/lazyChunk";

export const PixieChunk = lazyChunk(
  () => import("@/components/shopwindow/ask/AskShopWindow"),
  "pixie",
);

const preload = () => PixieChunk.preload();

// Spread on a control that opens Pixie: hover, focus or touch starts the load.
export const pixieIntentProps = {
  onPointerEnter: preload,
  onFocus: preload,
  onTouchStart: preload,
};

let idleScheduled = false;

/** Loads Pixie once the page is idle. Call it when Pixie becomes available. */
export function preloadPixieWhenIdle() {
  if (idleScheduled) {
    return;
  }
  idleScheduled = true;
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(preload);
  } else {
    setTimeout(preload, 2000);
  }
}
